import type { CuratedStory } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface CarouselBwCoversIntegrityProps {
    items: CuratedStory[];
}

export default function integrityCheck({
    items = [],
}: CarouselBwCoversIntegrityProps): IntegrityStatus {
    // This filter is needed because items can be added to this
    // array by an auto-fill before they are decorated with a
    // magazine cover image. The component has a corresponding
    // filter to remove invalid items prior to rendering, we're
    // copying that logic here. BW - 2/09/23
    const itemsWithCoverImage = items?.filter((item) =>
        Boolean(item && item.magazineCoverImage)
    );

    return checkItemArrayIntegrity(itemsWithCoverImage);
}
